// extracted by mini-css-extract-plugin
export default {"layout":"_3644514dea bb34fa5772 ff888157d4","h_slide":"f4a9fc1164","category":"_9110c32ac1 _23a3cb43db _1e03890f36"};